import { FilmIcon } from '@heroicons/react/outline';

export function VideoFileIcon() {
  return <FilmIcon className="h-full text-file-movie-enabled" />;
}
